import { gql } from 'apollo-angular'

/**
 * One randomly picked advertisement that is valid right now for the given
 * placement.
 *
 * All of the "is this ad allowed here" logic (active flag, date windows,
 * magazine/article targeting) lives in the API's `randomAdvertisement`
 * resolver: it gathers every candidate and returns one at random, or `null`
 * when there is nothing to show. `alt` follows the request locale, which the
 * `Accept-Language` header set in graphql.module.ts already carries.
 */
export const GET_RANDOM_ADVERTISEMENT = gql`
  query RandomAdvertisement(
    $placement: AdvertisementPlacement!
    $referenceId: Int
  ) {
    randomAdvertisement(placement: $placement, referenceId: $referenceId) {
      id
      url
      newTab
      alt
      imageDesktop {
        url
        width
        height
      }
      imageMobile {
        url
        width
        height
      }
    }
  }
`
